import React from 'react'

const ProfileSectionSearchTags = ({ profile }) => {
  console.log(profile)

  const titles = profile.tags.map((t, idx) => {
    return {
      text: t.name,
      value: 1 + idx
    }
  })
  const rotate = word => word.value % 360
  // console.log(titles)

  return (
    <ul>
      {profile.tags.map(t => {
        return (
          <li className="tag" style={{ fontSize: '16px', fontWeight: 'bold' }}>
            {t.name}
          </li>
        )
      })}
    </ul>
  )
}

export default ProfileSectionSearchTags
